// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"253957c0","990":"96e8d15b"}[chunkId] + ".chunk.js";
};